module.exports = __webpack_public_path__ + "img/splitter-south.e16b0976.png";